import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '@/views/Home.vue'
import Terms from '@/views/Terms.vue'
import Privacy from '@/views/Privacy.vue'
import Licenses from '@/views/Licenses.vue'
import YouthProtection from '@/views/YouthProtection.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/policy/terms',
    name: 'Terms',
    component: Terms,
    meta: { title: '비긴어게인 | 이용약관' }
  },
  {
    path: '/policy/privacy',
    name: 'Privacy',
    component: Privacy,
    meta: { title: '비긴어게인 | 개인정보처리방침' }
  },
  {
    path: '/policy/licenses',
    name: 'Licenses',
    component: Licenses,
    meta: { title: '비긴어게인 | 오픈소스 라이선스' }
  },
  {
    path: '/policy/youth-protection',
    name: 'YouthProtection',
    component: YouthProtection,
    meta: { title: '비긴어게인 | 청소년 보호 정책' }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: '비긴어게인 - 진지한 돌싱을 위한 돌싱 전문 매칭 서비스' }
  },
  {
    path: '',
    redirect: { name: 'Home' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (_to, _from, _savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((_to, _from, next) => {
  if (_to.meta && _to.meta.title) document.title = _to.meta.title
  next()
})

router.afterEach((_to, _from) => {
  if (window.fbq) window.fbq('track', 'PageView')
})

export default router
